import type { Stand } from './stand';

export type FlagDefinition = Readonly<{
  /** What the flag hides, in one sentence. Markdown links `[text](https://...)` are clickable. */
  description: string;
  /** Value on each stand. */
  enabled: Readonly<Record<Stand, boolean>>;
}>;

export type FlagDefinitions = Readonly<Record<string, FlagDefinition>>;

export type FlagValues<Name extends string = string> = Readonly<
  Record<Name, boolean>
>;

export type PartialFlagValues<Name extends string = string> = Partial<
  Record<Name, boolean>
>;

/**
 * Register the app's flags to type flag names in hooks and components:
 *
 * declare module '@packages/feature-flags' {
 *   interface Register {
 *     flags: typeof featureFlagDefinitions;
 *   }
 * }
 */
export interface Register {}

export type RegisteredFlags = Register extends {
  flags: infer T extends FlagDefinitions;
}
  ? T
  : FlagDefinitions;

export type FlagName = keyof RegisteredFlags & string;

export function defineFeatureFlags<const T extends FlagDefinitions>(
  definitions: T
): T {
  return definitions;
}
